import React from 'react';
import { adminAPI } from '../services/api';

interface User {
  _id: string;
  name: string;
  email: string;
  phone?: string;
  createdAt: string;
}

interface UsersManagementProps {
  users: User[];
  onRefresh: () => void;
}

const UsersManagement: React.FC<UsersManagementProps> = ({ users, onRefresh }) => {
  const handleDelete = async (id: string) => {
    if (window.confirm('Are you sure you want to delete this user?')) {
      try {
        await adminAPI.deleteUser(id);
        alert('User deleted successfully');
        onRefresh();
      } catch (error) {
        alert('Failed to delete user');
      }
    }
  };

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">Users Management</h2>
      </div>

      {users.length === 0 ? (
        <div className="empty-state">
          <h3>No Users Found</h3>
          <p>There are no registered users in the system.</p>
        </div>
      ) : (
        <div className="data-table">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Joined</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user._id}>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>{user.phone || 'N/A'}</td>
                  <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                  <td>
                    <button className="action-btn delete-btn" onClick={() => handleDelete(user._id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default UsersManagement;
